<template>
  <sliderBarDialogShell
   ref="shell"
    :dialog-show="dialogShow"
    :dialog-title="title"
      @close="beforeClose"
      @submit="confirm"
    class="addMaterialImgDialog"
  >
    <material-img-form
      ref="outform"
      @submit="submit"
    ></material-img-form>
  </sliderBarDialogShell>
</template>

<script>
import {uploadFileOld} from "../../../../utils/uploadFile";
import materialImgForm from "@/components/wx/material/material/materialImgForm";

export default {
  name: "addMaterialImgDialog",
  components: {
    materialImgForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      title: '新增图片素材'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(form,file) {
      // 调试需要,请求需要调整file参数,应该改为传url
      let formSlef = new FormData();
      formSlef.append('mediaId', form.mediaId || '')
      formSlef.append('file', file)
      formSlef.append('fileName', form.fileName)
      formSlef.append('mediaType', form.mediaType);
      this.$refs.shell.loading = true;
      uploadFileOld(formSlef).then((rs) => {
        this.$refs.shell.loading = false;
        if (rs.data.code === 200) {
          this.$emit('add-success')
          this.$message.success("添加成功");
        } else {
          this.$message.error("文件上传失败：" + rs.msg)
        }
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .addMaterialImgDialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
